<template>
    <div class="pa-5 compact-form" v-if="activeShop">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Shop name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.name"
                    @input="updateField($event, 'name')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Type" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.type"
                    @input="updateField($event, 'type')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.comment"
                    @input="updateField($event, 'comment')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.address"
                    @input="updateField($event, 'address')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "City" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.address_place"
                    @input="updateField($event, 'address_place')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Parish" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.address_parish"
                    @input="updateField($event, 'address_parish')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "County" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.address_county"
                    @input="updateField($event, 'address_county')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col cols="6">
                <v-autocomplete
                    v-model="country"
                    :items="countries"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    :item-text="
                        item =>
                            (item.name_et ? item.name_et : null) +
                            (item.name_en ? item.name_en : null) +
                            ' (' +
                            item.code +
                            ')'
                    "
                    item-value="code"
                    outlined
                    :placeholder="t('Start typing to Search')"
                    return-object
                >
                    <template slot="selection" slot-scope="{ item, selected }">
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                    <template slot="item" slot-scope="{ item, tile }">
                        <country-flag :country="item.code" size="small" class="mr-1" />
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col :cols="1">
                <country-flag v-if="country && country.code" :country="country.code" class="mt-0 ml-1" size="normal" />
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Latitude" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.latitude"
                    @input="updateField($event, 'latitude')"
                    class="text-field-item mb-1"
                    hide-details
                    type="number"
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Longitude" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.longitude"
                    @input="updateField($event, 'longitude')"
                    class="text-field-item mb-1"
                    hide-details
                    type="number"
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Additional field" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.additional_field"
                    @input="updateField($event, 'additional_field')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Image" | t }}</v-col>
            <v-col cols="6">
                <v-file-input
                    show-size
                    hide-details
                    dense
                    accept="image/*"
                    :label="activeShop.image ? activeShop.image : t('Upload')"
                    :value="activeShop.image"
                    @change="updateImageField($event)"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";
import CountryFlag from "vue-country-flag";

export default {
    name: "general-info-edit-tab",
    data() {
        return {
            country: {},
            isLoading: true
        };
    },
    components: {
        CountryFlag
    },
    async mounted() {
        if (this.countries.length === 0) {
            await Store.dispatch("fetchCountries");
        }

        await setTimeout(async () => {
            if (this.activeShop.address_country) {
                this.country = await this.countries.find(x => x.code === this.activeShop.address_country);
            }
        }, 200);
        this.isLoading = false;
    },
    watch: {
        country: function(value) {
            value && value.code
                ? this.updateField(value.code, "address_country")
                : this.updateField(null, "address_country");
        }
    },
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop"]),
        ...mapState(["countries"])
    },
    methods: {
        updateField(value, field) {
            Store.commit("ShopsAdminStore/updateActiveShopProperty", { prop: field, value: value });
        },
        updateStoreField(value, field) {
            Store.commit("ShopsAdminStore/updateActiveShopStoreProperty", { prop: field, value: value });
        },
        updateImageField(e) {
            Store.commit("ShopsAdminStore/setImageFile", { value: e });
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
